import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxDropDownListModule } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxInputModule } from 'jqwidgets-ng/jqxinput';
import { FormsModule } from '@angular/forms';
import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';
import { AppMenuEmpComponent } from './app-menu-emp.component';
import { jqxWindowModule } from 'jqwidgets-ng/jqxwindow';
import { NzModalModule } from 'ng-zorro-antd/modal';

@NgModule({
  declarations: [AppMenuEmpComponent],
  imports: [
    CommonModule,
    FormsModule,
    jqxLoaderModule,
    jqxButtonModule,
    jqxDropDownListModule,
    jqxInputModule,
    jqxWindowModule,
    jqxGridModule,
    NzModalModule,
  ],
  exports: [AppMenuEmpComponent],
})
export class AppMenuEmpModule {}
